"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _lodash = require("lodash");

var _calicoUiKit = require("@calico/calico-ui-kit");

var Author = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Author, _React$Component);

  function Author() {
    (0, _classCallCheck2.default)(this, Author);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Author).apply(this, arguments));
  }

  (0, _createClass2.default)(Author, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style;
      var _this$props2 = this.props,
          affiliations = _this$props2.affiliations,
          credentials = _this$props2.credentials,
          email = _this$props2.email,
          nameFirst = _this$props2.nameFirst,
          nameLast = _this$props2.nameLast,
          researchGate = _this$props2.researchGate,
          title = _this$props2.title,
          twitter = _this$props2.twitter;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('author', className),
        style: style
      }, _react.default.createElement("div", {
        className: "author-name"
      }, _react.default.createElement("strong", null, nameFirst, " ", nameLast)), _react.default.createElement("div", {
        className: "author-affiliations"
      }, affiliations.map(function (affiliation, a) {
        return _react.default.createElement("div", {
          key: a
        }, affiliation.title && _react.default.createElement("span", null, affiliation.title, ", "), affiliation.organization);
      })));
    }
  }]);
  return Author;
}(_react.default.Component);

Author.defaultProps = {
  affiliations: [],
  // [{ organization: '', title: '' }]
  credentials: null,
  email: null,
  nameFirst: '',
  nameLast: '',
  pictureUrl: null,
  researchGate: null,
  twitter: null
};
var _default = Author;
exports.default = _default;